
import React from "react";
import Logo from "../../assets/logo-white.png";
import client from "../../clients";
import "./style.scss";

const SplashScreen = () => {
  return (
    <div className="splash-container">
      <img className="fadeIn logo" src={client.type == "agm" ? client.logoWhite : client.logo} />
    </div>
  );
};

export default SplashScreen;